import HeaderBreadcrumbs from './header-breadcrumbs';

export default HeaderBreadcrumbs;
